import React from "react";
import { Button, Flex, useMediaQuery } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { HiOutlinePhone, HiOutlineChatBubbleLeftRight } from "react-icons/hi2";

/**
 * Sticky bottom bar shown on mobile only, offering two big touch targets:
 * "Call" and "Get a quote". Hidden on the /contact-us page itself.
 */
const MobileCTA = () => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!isMobile) return null;
  if (pathname.startsWith("/contact-us")) return null;
  if (pathname.startsWith("/portal")) return null;

  return (
    <Flex
      pos="fixed"
      bottom="14px"
      left="50%"
      transform="translateX(-50%)"
      zIndex={888}
      w="calc(100% - 24px)"
      maxW="440px"
      p="6px"
      borderRadius="18px"
      bg="rgba(10,22,40,0.86)"
      backdropFilter="blur(14px) saturate(1.6)"
      border="1px solid rgba(255,255,255,0.12)"
      boxShadow="0 20px 40px -10px rgba(15,23,42,0.4)"
      gap="6px"
    >
      <Button
        variant="glass"
        as="a"
        href="tel:08055058367"
        leftIcon={<HiOutlinePhone size="18px" />}
        h="46px"
        fontSize="13px"
        flex="1"
      >
        Call
      </Button>
      <Button
        onClick={() => navigate("/contact-us")}
        leftIcon={<HiOutlineChatBubbleLeftRight size="18px" />}
        h="46px"
        fontSize="13px"
        flex="1.4"
      >
        Get a quote
      </Button>
    </Flex>
  );
};

export default MobileCTA;
